const lang = {
    'hop-on': 'Hop On!',
    'decription-1': '<span class="text-wrap-sm">一鍵啟動，在城市兜兜風！</span>不管是上班通勤，下班玩樂，<span class="text-wrap-sm">朋友聚會或是假日出遊，</span> GoShare 與你一同探索<span class="text-wrap-sm">城市移動的無限可能！</span>',
    'decription-2': '<span class="text-wrap-sm">有了 GoShare 和 GoShare DOTS，</span>暢遊城市就是那麼簡單！<span class="text-wrap">搜尋、預訂、騎乘 Gogoro </span><span class="text-wrap-ex-sm"><span class="text-wrap-sm">與 Powered by Gogoro Network (PBGN) </span>智慧電動機車，</span>隨時借還超方便。',
};

export default lang;
